export function getResFilename(res) {
    return res.headers.get('Content-Disposition')?.split('filename="')[1].split('"')[0] || 'document';
}
